import { SEGMENT_URL, WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';

const getSegments = (webId) => ky.get(`${WEBSITE_URL}${webId}/segments/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getCommonSegments = () => ky.get(`${SEGMENT_URL}common/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const deleteSegments = (webId, id) => ky.delete(`${WEBSITE_URL}${webId}/segments/${id}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getSegmentProperties = (webId) => ky.get(`${WEBSITE_URL}${webId}/segments/properties/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const saveSegment = (webId, segmentData) => ky.post(`${WEBSITE_URL}${webId}/segments/`, {
    json: segmentData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const saveMultiSeg = (segmentData) => ky.post(`${SEGMENT_URL}multi/`, {
    json: segmentData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getReach = (webId, rules) => ky.post(`${WEBSITE_URL}${webId}/segments/reach/`, {
    json: rules,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export { getSegments, deleteSegments, getSegmentProperties, saveSegment, getReach, saveMultiSeg, getCommonSegments }